import React from 'react';
import PropTypes from 'prop-types';
import './disclaimer.scss';

// Components
// ---------------------
import { Accordion } from '../accordion/accordion';

export const Disclaimer = ({ text, disclaimerText, ...props }) => {
  return (
    <div className="disclaimer-component">
      <Accordion text={`${text} Disclaimer`}>
        <div
          className="disclaimer"
          dangerouslySetInnerHTML={disclaimerText}
        ></div>
      </Accordion>
    </div>
  );
};

Disclaimer.propTypes = {
  text: PropTypes.string,
  disclaimerText: PropTypes.object,
};
